import CellFirstRow from "./CellFirstRow";
import CellSecondRow from "./CellSecondRow";
import CellEmptyRow from "./CellEmptyRow";
import CellContainerRow from "./CellContainerRow";

import Icon from "@material-ui/core/Icon";
import Typography from "@material-ui/core/Typography";

// Utils
import { formatDate } from "app/main/utils/dateUtils";

const getScheduleStatusStyle = (schedule) => {
	const now = new Date();
	const startTime = new Date(schedule.start_datetime);
	const endTime = new Date(schedule.end_datetime);

	if (now >= startTime && now <= endTime) {
		return "text-green-700"; // Active
	} else if (now < startTime) {
		return "text-blue-700"; // Upcoming
	} else {
		return "text-grey"; // Past
	}
};

const getScheduleStatusLabel = (schedule) => {
	const now = new Date();
	const startTime = new Date(schedule.start_datetime);
	const endTime = new Date(schedule.end_datetime);

	if (now >= startTime && now <= endTime) {
		return "Active";
	} else if (now < startTime) {
		return "Upcoming";
	} else {
		return "Past";
	}
};

function ScheduleCellView(props) {
	const mobile = props.mobile;
	const config = props.config;
	const variant = props.variant;
	const item = props.item;

	const view = Array.isArray(props.view) ? props.view?.[0] : props.view;
	const schedules = view?.metadata?.schedules || [];
	const upcomingSchedules = view?.metadata?.upcoming_schedules || [];

	// Show all schedules sorted by start_datetime ascending
	let displaySchedules = [...schedules].sort((a, b) => new Date(a.start_datetime) - new Date(b.start_datetime));

	if (!view?.value || displaySchedules.length === 0) {
		return <CellEmptyRow mobile={mobile} variant={variant} />;
	}

	const buildScheduleItem = (schedule, more) => {
		const scheduleStatus = getScheduleStatusLabel(schedule);
		const scheduleStatusStyle = getScheduleStatusStyle(schedule);

		return (
			<CellContainerRow
				mobile={mobile}
				key={schedule.id}
				variant={variant}
				first={
					<div className="flex flex-wrap">
						<CellFirstRow
							mobile={mobile}
							view={{
								label:
									`${schedule.origin_yard?.address} → ${schedule.destination_yard?.address}` ||
									`Schedule ${schedule.schedule_type}`,
								value: schedule.id,
							}}
							dialog={{
								viewId: "SCHEDULE_VIEW",
								dataIds: {
									scheduleId: schedule.id,
									scheduleInstanceId: schedule.id,
									carrierId: item.carrier,
									truckId: item._id,
									readOnly: config?.readOnly,
								},
							}}
							variant={variant}
						/>
						{config?.showStatus && (
							<CellSecondRow
								mobile={mobile}
								label={scheduleStatus}
								variant={variant}
								classes={{ label: "ml-4" }}
								color={scheduleStatusStyle}
							/>
						)}
					</div>
				}
				second={
					<div className="flex flex-wrap">
						<div className="flex flex-row whitespace-nowrap">
							{config?.showType && <CellSecondRow mobile={mobile} label={schedule.schedule_type} variant={variant} />}
							{config?.showDateTime && (
								<CellSecondRow
									mobile={mobile}
									icon="schedule"
									label={formatDate(schedule.start_datetime)}
									variant={variant}
								/>
							)}
							{/*config?.showDuration && schedule.estimated_duration_hours && (
								<CellSecondRow
									mobile={mobile}
									icon="timer"
									label={`${schedule.estimated_duration_hours}h`}
									variant={variant}
								/>
							)}*/}
						</div>
						{config?.showEquipment && schedule.equipment_types && (
							<CellSecondRow
								mobile={mobile}
								label={
									Array.isArray(schedule.equipment_types)
										? schedule.equipment_types.join(", ")
										: schedule.equipment_types
								}
								variant={variant}
							/>
						)}
					</div>
				}
				more={more}
			/>
		);
	};

	let extra = [];
	if (displaySchedules.length > 1) {
		for (let i = 1; i < displaySchedules.length; i++) {
			extra.push(buildScheduleItem(displaySchedules[i]));
		}
	}

	return buildScheduleItem(displaySchedules[0], extra);
}

export default ScheduleCellView;
